import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../App";
import { History } from "lucide-react";

export const ImportHistory = ({ refreshKey }) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    axios.get(`${API}/pic-to-lead/history`, { params: { limit: 25 } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); })
      .catch(() => {});
  }, [refreshKey]);

  return (
    <div className="content-card" data-testid="pic-history-card">
      <div className="card-header">
        <h2 className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}><History size={18} /> Import history ({total})</h2>
      </div>
      {items.length === 0 ? (
        <p style={{ color: "#64748b" }} data-testid="pic-history-empty">No contacts imported yet. Upload a photo above to get started.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="data-table" style={{ width: "100%" }} data-testid="pic-history-table">
            <thead>
              <tr><th>Name</th><th>Company</th><th>Email</th><th>Phone</th><th>Status</th><th>By</th><th>Date</th></tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} data-testid={`pic-history-row-${i.id}`}>
                  <td>{[i.first_name, i.last_name].filter(Boolean).join(" ") || "—"}</td>
                  <td>{i.company || "—"}</td>
                  <td>{i.email || "—"}</td>
                  <td>{i.phone || "—"}</td>
                  <td title={i.error || ""} style={{ color: i.status === "success" ? "#15803d" : "#b91c1c", fontWeight: 600 }}>
                    {i.status === "success" ? "Imported" : "Failed"}
                  </td>
                  <td>{i.imported_by}</td>
                  <td>{new Date(i.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
